export default __webpack_public_path__ + "static/media/sello-garantia.dc02a8ba.jpg";